import { AfterNode, afterImplementation } from "./after.js";
import { BeforeNode, beforeImplementation } from "./before.js";
import { ExactLengthNode, exactLengthImplementation } from "./exactLength.js";
import { MaxNode, maxImplementation } from "./max.js";
import { MaxLengthNode, maxLengthImplementation } from "./maxLength.js";
import { MinNode, minImplementation } from "./min.js";
import { MinLengthNode, minLengthImplementation } from "./minLength.js";
export const boundImplementationsByKind = {
    min: minImplementation,
    max: maxImplementation,
    minLength: minLengthImplementation,
    maxLength: maxLengthImplementation,
    exactLength: exactLengthImplementation,
    after: afterImplementation,
    before: beforeImplementation
};
export const boundClassesByKind = {
    min: MinNode,
    max: MaxNode,
    minLength: MinLengthNode,
    maxLength: MaxLengthNode,
    exactLength: ExactLengthNode,
    after: AfterNode,
    before: BeforeNode
};
